import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import finalLogo from "../../Images/Production_logo.PNG";
import "./Cnav.css";
import Hamburger from "../Hamburger/Hamburger";
const Cnav = ({ galleryColor, contactColor }) => {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    // console.log("executed", showNavbar);
    setShowNavbar(!showNavbar);
  };

  const currentWindow = useLocation();
  const styles = {
    galleryNavLink: {
      color: galleryColor,
    },
    contactNavLink: {
      color: contactColor,
    },
    none: {},
  };

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/", { replace: true });
  };

  const onClickHandle = () => {
    navigate("/booking", { replace: true });
  };

  const handleOnGalleryClick = () => {
    navigate("/gallery", { replace: true });
  };

  const onClickContactHandle = () => {
    navigate("/contact", { replace: true });
  };

  const handleAnywhereClick = () => {
    // console.log("handle anywhere click executed");
    if (window.innerWidth <= 600) {
      if (showNavbar) setShowNavbar(!showNavbar);
    }
  };

  return (
    <div className="cnavbar" onClick={handleAnywhereClick}>
      <div className="bnav">
        <div className="b-left">
          <img
            src={finalLogo}
            alt="four seasons resort, jamshedpur"
            className="logo-image-size"
          />
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <Hamburger />
        </div>
        <div className={`b-right ${showNavbar && "active"}`}>
          <ul className="b-list">
            <li onClick={handleClick} className="c-r-list">
              Home
            </li>
            <li onClick={onClickHandle} className="c-r-list">
              Booking
            </li>
            <li
              onClick={handleOnGalleryClick}
              className="c-r-list"
              style={
                currentWindow.pathname === "/gallery" && window.innerWidth > 600
                  ? styles.galleryNavLink
                  : styles.none
              }
              id={
                currentWindow.pathname === "/gallery" ? "b-r-list-booking" : ""
              }
            >
              Gallery
            </li>
            <li
              onClick={onClickContactHandle}
              className="c-r-list"
              style={
                currentWindow.pathname === "/contact" && window.innerWidth > 600
                  ? styles.contactNavLink
                  : styles.none
              }
              id={
                currentWindow.pathname === "/contact" ? "b-r-list-booking" : ""
              }
            >
              Contact
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Cnav;
